import React from 'react'

const StatsPage = () => {
  // show book and category stats.
  // stats:
    // book count
    // read/unread/dnf book count
    // books count in each category
    // read/unread/dnf book count within each category
    // author count
    // top 5 authors (most books)
  // MVP: display numbers statically
  // GOAL: charts/graphs to visualize data
  return (
    <div>StatsPage</div>
  )
}

export default StatsPage
